var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconToggleCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.947952 9.93842C0.70278 9.95267 0.461663 9.87117 0.275444 9.71109C-0.0918148 9.34165 -0.0918148 8.74497 0.275444 8.37552L8.31722 0.333721C8.6992 -0.0237129 9.29859 -0.00384334 9.65603 0.378139C9.97924 0.723563 9.99808 1.25449 9.70013 1.62194L1.61098 9.71109C1.42716 9.86886 1.18991 9.95021 0.947952 9.93842Z",
    fill: "#BD000B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98023 9.93844C8.73175 9.93738 8.4936 9.83875 8.31717 9.66376L0.275368 1.62193C-0.0648786 1.2246 -0.0186203 0.626638 0.378708 0.286361C0.733335 -0.0173285 1.25634 -0.0173285 1.61093 0.286361L9.70009 8.32816C10.082 8.68569 10.1017 9.28512 9.74419 9.667C9.72997 9.68219 9.71528 9.69689 9.70009 9.71111C9.50201 9.88335 9.24134 9.96567 8.98023 9.93844Z",
    fill: "#BD000B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToggleCross);
export default __webpack_public_path__ + "static/media/iconToggleCross.120ed6fd8f4f7e8d15f444aed0bd8fc5.svg";
export { ForwardRef as ReactComponent };